module.exports = __webpack_public_path__ + "static/nodejs-dev-tool-notes-01-1de4e2fbda71bf2f329c3ad787b809bf.png";